export default defineNuxtPlugin((nuxtApp) => {
    const originalWarn = console.warn;
  
    console.warn = (message, ...args) => {
        // Supress warning about no match found for location with path
      if (!message.includes('No match found for location with path')) {
        originalWarn(message, ...args);
      }
    };
  })
  